import React, { useRef, useState, useMemo } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const MultiColumnMultiSelect = ({
    value = [],
    options = [],
    columns = [],
    optionValue = 'value',
    optionLabel = 'label',
    placeholder = 'Select',
    onChange,
    multiple = true,
    panelWidth = '800px',
    scrollHeight = '350px'
}) => {
    const op = useRef(null);
    const [filter, setFilter] = useState('');

    const selectedValues = multiple
    ? (Array.isArray(value) ? value : [])
    : value;

    const filteredData = useMemo(() => {
        if (!filter) {
            return options;
        }

        return options.filter(item =>
            Object.values(item)
                .join(' ')
                .toLowerCase()
                .includes(filter.toLowerCase())
        );
    }, [options, filter]);

    const handleSelection = (e) => {
        if (onChange) {
            onChange(e.value);
        }
          // Auto close only for single select
    if (!multiple && op.current) {
        op.current.hide();
    }
    };

    const displayText = () => {

    if (multiple) {

        if (!selectedValues.length) {
            return placeholder;
        }

        if (selectedValues.length <= 2) {
            return selectedValues
                .map(item => item[optionLabel])
                .join(', ');
        }

        return `${selectedValues.length} selected`;
    }

    // Single Select

    if (!value) {
        return placeholder;
    }

    return value[optionLabel];
};

    return (
        <>
            <div
                className="p-inputtext p-component p-col-12"
                style={{
                    cursor: 'pointer',
                    minHeight: '40px',
                    display: 'flex',
                    alignItems: 'center'
                }}
                onClick={(e) => op.current.toggle(e)}
            >
                {displayText()}
            </div>

            <OverlayPanel
                ref={op}
                style={{ width: panelWidth }}
            >
                <div style={{ marginBottom: '1rem' }}>
                    <InputText
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        placeholder="Search..."
                        style={{ width: '100%' }}
                    />
                </div>

                <DataTable
                    value={filteredData}
                    selection={selectedValues}
                    onSelectionChange={handleSelection}
                    dataKey={optionValue}
                    scrollable
                    scrollHeight={scrollHeight}
                    selectionMode={multiple ? 'checkbox' : 'single'}
                >
                    {multiple && (
                        <Column
                            selectionMode="multiple"
                            headerStyle={{ width: '3rem' }}
                        />
                    )}

                    {columns.map(col => (
                        <Column
                            key={col.field}
                            field={col.field}
                            header={col.header}
                            sortable={col.sortable !== false}
                        />
                    ))}
                </DataTable>

                <div
                    className="p-d-flex p-jc-between p-ai-center"
                    style={{ marginTop: '1rem' }}
                >
                    <span>
                        Selected : {multiple ? selectedValues.length : (selectedValues ? 1 : 0)}
                    </span>

                    <Button
                        label="Close"
                        icon="pi pi-times"
                        className="p-button-sm"
                        onClick={() => op.current.hide()}
                    />
                </div>
            </OverlayPanel>
        </>
    );
};

export default MultiColumnMultiSelect;